import privateImage from '../assets/private-project.jpg'

const Projects = () => {

  let projectList = [
    {
      key: '1',
      name: 'Data Mesh Fabric',
      photo: '../assets/main-bg.jpg',
      description: 'The Data Mesh Fabric is a solution that creates a governed mesh architecture, enabling data producers to share their data products with consumers.',
    },
    {
      key: '2',
      name: 'Data Lake Fabric',
      photo: 'assets/pexels-harold-vasquez-853421-2653362.jpg',
      description: 'The Data Lake Fabric is a data platform designed for users who are new to AWS or have limited AWS knowledge but still need to create data pipelines.',
    },
    {
      key: '3',
      name: 'GenAI Summarizer Application',
      photo: 'assets/pexels-harold-vasquez-853421-2653362.jpg',
      description: 'The Gen AI Summarizer harnesses Generative AI to streamline the creation of summarized documents. It automates the processes of context retrieval, LLM-based summarization, and documentation.',
    },
    {
      key: '4',
      name: 'PRIMECore',
      photo: 'assets/pexels-harold-vasquez-853421-2653362.jpg',
      description: "PRIMECore is an application that manages the company's property listings, and projects providing a centralized platform for tracking, and organizing all relevant data related to the real estate business.",
    },
    {
      key: '5',
      name: 'PRIMECore Mobile',
      photo: 'assets/pexels-harold-vasquez-853421-2653362.jpg',
      description: 'PRIMECore Mobile is the mobile counterpart of PRIMECore, developed using React Native to provide users with seamless access to the platform on their smartphones.',
    },
    {
      key: '6',
      name: 'Norde Intranet',
      photo: 'assets/pexels-harold-vasquez-853421-2653362.jpg',
      description: "Norde Intranet is a private web application that manages company events, announcements, and allows users to post messages and communicate internally.",
    }
  ]

  return (
    <section id="projects">
      <h2>Projects</h2>
      <p className='description'>These are the projects I have had the privilege of contributing to, showcasing my skills and expertise in various areas of software development.</p>
      <div className="projects-container">
        {projectList.map((details) => (
          <div className="project-card" key={details.key}>
            <div className='overlay-container'>
              <img src={privateImage} alt={details.name} width="100%" height={180} />
              <div className="overlay">Due to confidentiality, I can't provide a photo of this application.</div>
            </div>
            <h3>{details.name}</h3>
            <p>{details.description}</p>
          </div>
        ))}
      </div>
    </section>
  )
};
export default Projects;